export default __webpack_public_path__ + "assets/images/coin.041255.avif";